import Moment from 'moment'

export function dateFormat (date, isTimestamp = false, format = 'YYYY-MM-DD') {
  if (isTimestamp) date = new Date(date * 1000)
  return Moment(date).format(format)
}
